<template>
  <div class="showPageDiv">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="showCurrentPage"
      :page-size="showPageSize"
      layout="total,prev, pager, next, jumper"
      :total="showTotal">
    </el-pagination>
  </div>
</template>
<script>
  export default {
    props:{
      showTotal:{
        type: Number,
        default: 0 ,
      },
      showPageSize:{
        type: Number,
        default: 10 ,
      },
      showDefaultPage:{
        type: Number,
        default: 1 ,
      }
    },
    data() {
      return {
        showCurrentPage: this.showDefaultPage ,
      };
    },
    methods: {
       //每页显示数据切换
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
       //页码切换
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.showCurrentPage = val;
        this.$emit("onPagechange", val);
      }
    },
  }
</script>
<style lang="less" scoped>
.showPageDiv{
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  border-top: 1px solid #DFDADA;
  text-align: right;

  /deep/.el-pagination{
    float: right;
    margin-right: 20px;
    padding: 0;
    height: 34px;
    padding-top: 6px;
  }
  /deep/.li {
    color: #333333;
  }
  /deep/.el-pager li.active{
    color: #c03429;
  }

  /deep/.el-pager li:hover {
    color: #c03429;
  }
}
</style>